const LEGACY_WORKER_PATH = "/sw.js";
const LEGACY_PRECACHE_PREFIX = "workbox-precache-";

/**
 * Retires only the legacy root-scoped Owner Portal worker and its generated
 * precache. Other service-worker scopes and runtime caches on the origin are
 * left alone.
 */
export async function retireOwnerPortalServiceWorker(): Promise<void> {
  if (!("serviceWorker" in navigator)) return;

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(
      registrations
        .filter((registration) => {
          const worker = registration.active ?? registration.waiting ?? registration.installing;
          if (!worker || !window.location.href.startsWith(registration.scope)) return false;
          return new URL(worker.scriptURL).pathname === LEGACY_WORKER_PATH;
        })
        .map((registration) => registration.unregister()),
    );

    if (!("caches" in window)) return;
    const cacheNames = await caches.keys();
    await Promise.all(
      cacheNames
        .filter((cacheName) => cacheName.startsWith(LEGACY_PRECACHE_PREFIX))
        .map((cacheName) => caches.delete(cacheName)),
    );
  } catch {
    // Cleanup is best-effort. A static retirement worker at /sw.js also
    // handles clients still controlled by an older cached application shell.
  }
}
